export default __webpack_public_path__ + "static/media/cwu20.705edabf.jpeg";